/* eslint-disable react/forbid-dom-props */
import classnames from 'classnames';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { some, uniqBy } from 'lodash';
import Icon from '../Icon';
import Anchor from './Anchor';
import Anchors from './Anchors';
import AutoDocumentTitle from './AutoDocumentTitle';
import BreadcrumbsContext from './BreadcrumbsContext';
import QuickLinkModal from '../../forms/QuickLinkModal';
import styles from './Breadcrumbs.scss';
import helpNoteTitleIfPresent from '../Translations/helpNoteTitleIfPresent';
import useHelpNote from '../Translations/useHelpNote';
import useLayoutDirection from '../Translations/useLayoutDirection';
const Breadcrumbs = () => {
    const { breadcrumbs } = useContext(BreadcrumbsContext);
    const { direction, startSide, isLayoutRTL } = useLayoutDirection();
    const getHelpNoteTooltipTitle = useHelpNote();
    const homeIconPosition = isLayoutRTL ? 'position-right' : 'position-left';
    const crumbs = [
        {
            id: 'home',
            title: <Icon className={homeIconPosition} name="home2"/>,
            route: '/',
        },
        ...uniqBy(breadcrumbs.filter(({ depth }) => depth > 0), 'route'),
    ];
    const [first = null] = crumbs.length > 1 ? crumbs.slice(0, 1) : [];
    const [last = null] = crumbs.slice(-1);
    const other = crumbs.slice(1, -1);
    const hasQuickLinks = !some(breadcrumbs, ['hasQuickLinkButton', false]);
    return (<div className={styles.breadcrumbWrap} data-layout-direction={direction} dir={direction}>
      <ul className={classnames('breadcrumb breadcrumb-caret', {
        'pull-left': startSide === 'left',
        'pull-right': startSide === 'right',
    })}>
        {first && (<li key={`crumb-first-${first.route}`} title={helpNoteTitleIfPresent(getHelpNoteTooltipTitle, first.title)}>
            <Link className={styles.breadcrumbItem} to={first.route}>
              {first.title}
            </Link>
          </li>)}

        {other.map(crumb => (<li key={`crumb-${crumb.route}`} title={helpNoteTitleIfPresent(getHelpNoteTooltipTitle, crumb.title)}>
            <Link className={styles.breadcrumbItem} to={crumb.route}>
              {crumb.title}
            </Link>
          </li>))}

        {last && (<li key={`crumb-last-${last.route}`} className="active" title={helpNoteTitleIfPresent(getHelpNoteTooltipTitle, last.title)}>
            {last.title}
          </li>)}
        {hasQuickLinks && (<QuickLinkModal entity={{
        name: last && typeof last.title === 'string' ? last.title : '',
    }}/>)}
      </ul>
    </div>);
};
Breadcrumbs.Anchor = Anchor;
Breadcrumbs.Anchors = Anchors;
Breadcrumbs.AutoDocumentTitle = AutoDocumentTitle;
export default Breadcrumbs;
